export default __webpack_public_path__ + "static/media/72.cae185dc.png";